import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import EventNoteIcon from '@mui/icons-material/EventNote';
export const getStatusIcon = (status) => {
  switch (status) {
    case "compliant":
      return <CheckCircleIcon />;
    case "incompliant":
      return <ErrorIcon />;
    default:
      return <HourglassEmptyIcon />;
  }
};

export const getAvatarBgColor = (status) => {
  switch (status) {
    case "compliant":
      return "#4caf50";
    case "incompliant":
      return "#f44336";
    default:
      return "#ff9800";
  }
};

export const getResponseStatusIcon = (status) => {
  switch (status) {
    case "PENDING":
      return <PendingActionsIcon/>; // light gray

    case "WAITING_FOR_PLAN":
      return <EventNoteIcon/>; // light blue

     case "WAITING_FOR_EXIT_PLAN":
      return <EventNoteIcon/>; // light blue

    case "WAITING_FOR_APPROVALS":
      return <LibraryAddCheckIcon />; // dark orange

    case "EXIT_PLANS_APPROVED":
      return <CheckBoxIcon />; // light green

    case "COMPLETED":
return <DoneAllIcon sx={{ color: "green" }} />;

    default:
      return <HourglassEmptyIcon/>;
  }
};

export const getResponseStatusAvatarBgColor = (status) => {
  switch (status) {
    case "PENDING":
      return "#d3d3d3"; // light gray

    case "WAITING_FOR_PLAN":
      return "#0047AB"; // light blue

    case "WAITING_FOR_EXIT_PLAN":
      return "#0047AB"; // light blue

    case "WAITING_FOR_APPROVALS":
      return "#ff8c00"; // dark orange

    case "EXIT_PLANS_APPROVED":
      return "#818589"; // light green

    case "COMPLETED":
      return "green";

    default:
      return "#ff9800"; // fallback color
  }
};
